import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
  Switch,
  Grid2 as Grid,
  FormControlLabel,
  FormHelperText,
  FormControl,
  Grid2Props,
} from "@mui/material";
import { singleGridItem } from "../defaultStyles";
import { useInputFullName } from "../subForms/NamePrefixContext";
import { useFormHandlerContext } from "../../../../controllers/formController";

export interface FormSwitchProps extends Grid2Props {
  name?: string;
  disabled?: boolean;
  label: string;
}

export const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  label,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  const { control } = useFormContext();
  const fullName = useInputFullName(name);

  return (
    <Grid {...singleGridItem} {...grid}>
      <Controller
        name={fullName}
        control={control}
        render={({ field, fieldState }) => (
          <FormControl fullWidth error={!!fieldState.error}>
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  id={fullName}
                  checked={!!field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                  disabled={disabled || isProcessing}
                />
              }
              label={label}
            />
            {fieldState.error && (
              <FormHelperText>{fieldState.error?.message}</FormHelperText>
            )}
          </FormControl>
        )}
      />
    </Grid>
  );
};
